const IconOptionsEnum = {
  DRIVER: { icon: "truck", color: "#4A4A4A" },
  DELIVERED: { icon: "pack", color: "#409E6A" },
  PENDING: { icon: "pack", color: "#f5cb2b" },
  UNDELIVERED : { icon: "pack", color: "#f54c53" },
  DEFAULT: { icon: "default", color: "#B3B3B3" },
};

export default IconOptionsEnum;
